import { render, staticRenderFns } from "./LotTemplateSummary.vue?vue&type=template&id=4e8bfa8b&"
import script from "./LotTemplateSummary.vue?vue&type=script&lang=js&"
export * from "./LotTemplateSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports